import script from "./DecContent.vue?vue&type=script&setup=true&lang=js"
export * from "./DecContent.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__